import { appGetTokenInfoSuccess, appNoOp } from '@actions/app.action';
import {
  stationGetActiveStationsWithConnectionMarketsSuccess,
  stationGetActiveStationsWithMarketsSuccess,
} from '@actions/station.action';
import { Injectable } from '@angular/core';
import { FeatureFlagsEnum } from '@models/environment.type';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { StationService } from '@services/api-clients';
import { FeatureFlagService } from '@services/feature-flag/feature-flag.service';
import { of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

@Injectable()
export class StationEffect {
  constructor(
    private actions$: Actions,
    private stationService: StationService,
    private featureFlagService: FeatureFlagService,
  ) {}

  getActiveStationsWithMarkets$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(appGetTokenInfoSuccess),
      mergeMap(() =>
        this.stationService.getActiveStationsWithMarkets().pipe(
          map((response) =>
            stationGetActiveStationsWithMarketsSuccess({
              payload: response.data,
            }),
          ),
        ),
      ),
    );
  });

  getActiveStationsWithConnectionMarkets$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(appGetTokenInfoSuccess),
      mergeMap(() => {
        if (
          !this.featureFlagService.isFeatureActive(FeatureFlagsEnum.CONNECTIONS)
        ) {
          return of(appNoOp());
        }
        return this.stationService
          .getActiveStationsWithConnectionMarkets()
          .pipe(
            map((response) =>
              stationGetActiveStationsWithConnectionMarketsSuccess({
                payload: response.data,
              }),
            ),
          );
      }),
    );
  });
}
